import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../../services/archismall.service';

class PACaricaFatturaController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    '$uibModal'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $uibModal: ng.ui.bootstrap.IModalService
  ) {

    $scope.pageHeader = 'Carica fattura XML';
    store.remove('conservazioneClasseDocumentale');
    $scope.filesIndex = 0;
    $rootScope.filesUploadedNumber = 0;
    $scope.maxFilesToUpload = configuration.fatturaPAMaxFilesToUpload;
    let filesItem = {'file_id': '', 'file_name': '', 'short_name': ''}; // , file_icon: ''};

    let getSettingsDefault = () => {
      return {
        'username': $rootScope.currentUser().sub,
        'files': [],
        'queueId': '',
        // 'delete_icon': ''
        'uploadType': 3
      };
    };
    $scope.settings = getSettingsDefault();

    $scope.uploadFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
      if ($scope.filesIndex === $scope.maxFilesToUpload) {
        $rootScope.alert('warning', 'Puoi caricare solo ' + $scope.maxFilesToUpload + ' File(s) !');
        $rootScope.filesUploadedNumber--;
        return;
      }

      $scope.settings.files.push(jQuery.extend(true, {}, filesItem));
      $scope.settings.files[$scope.filesIndex].file_id = res.id;
      $scope.settings.files[$scope.filesIndex].file_name = res.name;
      $scope.settings.files[$scope.filesIndex].short_name = filename;
      $scope.extension = filename.split('.').pop().toLowerCase();
      $scope.filesIndex++;
      $scope.saveFilesInLocalStorage();
      store.set('fatturazionePACarica', 'true');
    };
    $scope.deleteFile = (index) => {
      $scope.settings.files.splice(index, 1);
      $scope.filesIndex--;
      $rootScope.filesUploadedNumber--;
      if ($scope.filesIndex > 0 && $rootScope.filesUploadedNumber > 0) {
        $scope.saveFilesInLocalStorage();
      } else {
        $scope.removeFilesFromLocalStorage();
        store.remove('fatturazionePACarica');
      }
    };
    $scope.next = (res) => {
      $scope.openWorkerChatModal('md');
    };
    // <editor-fold desc='openWorkerChatModal1'>
    $scope.openWorkerChatModal = (size) => {
      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerCaricaFatturePAModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };
    // </editor-fold>

    // <editor-fold desc='getFilesFromLocalStorage'>
    $scope.getFilesFromLocalStorage = () => {
      if (store.get('fatturazioneCaricaFatturaXML')) {
        $scope.settings = JSON.parse(store.get('fatturazioneCaricaFatturaXML'));
        if ($scope.settings.username === $rootScope.currentUser().sub) {
          $scope.filesIndex = $scope.settings.files.length;
        } else {
          store.remove('fatturazionePACarica');
          $scope.settings = getSettingsDefault();
        }
      } else {
        store.remove('fatturazionePACarica');
        $scope.settings = getSettingsDefault();
      }
    };

    $scope.getFilesFromLocalStorage();
    $scope.filesIndex = $scope.settings.files.length;
    $rootScope.filesUploadedNumber = $scope.filesIndex;
    // </editor-fold>

    // <editor-fold desc='saveFilesInLocalStorage'>
    $scope.saveFilesInLocalStorage = () => {
      store.set('fatturazioneCaricaFatturaXML', JSON.stringify($scope.settings));
    };
    // </editor-fold>

    // <editor-fold desc='removeFilesFromLocalStorage'>
    $scope.removeFilesFromLocalStorage = () => {
      store.remove('fatturazioneCaricaFatturaXML');
    };
    // </editor-fold>
  }

}

export const PACaricaFatturaComponent: ng.IComponentOptions = {
  template: require('./pa-carica-fattura.html'),
  controller: PACaricaFatturaController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-carica-fattura/pa-carica-fattura.ts